export const tasks = [{
    title: 'TRANSPORTATION CHECKLIST',
    data: [{
        title: "Change Commute",
        data: [
            {
                title: "Telecommute ays/wk ",
                score: 1
            },
            {
                title: "Ride bike___mi",
                score: 1
            },
            {
                title: "Teleconference___/year",
                score: 1
            },
            {
                title: "Reduce air travel by___%",
                score: 1
            },

        ]
    },
        {
            title: "Change Mode In Town ",
            data: [
                {
                    title: "Walk to restaurants",
                    score: 1
                },
                {
                    title: "Bike/skate for errands",
                    score: 1
                },
                {
                    title: "Ride bus to Sac or campus",
                    score: 1
                },


            ]
        }
        , {
            title: "Change Habits",
            data: [
                {
                    title: "Accelerate and brake slowly",
                    score: 1
                },
                {
                    title: "Maintain vehicles regularly",
                    score: 1
                },
                {
                    title: "Reduce speed by 15mph",
                    score: 1
                },
                {
                    title: "Consolidate trips",
                    score: 1
                },
                {
                    title: "Take staycations",
                    score: 1
                },
                {
                    title: "Bike with friends & family",
                    score: 1
                },


            ]

        },
        {
            title: "Change Vehicle",
            data: [
                {
                    title: "Drive more efficient vehicle",
                    score: 1
                },
                {
                    title: "Drive an electric vehicle",
                    score: 1
                },
                {
                    title: "Drive a hybrid vehicle",
                    score: 1
                },
                {
                    title: "Drive a micro vehicle",
                    score: 1
                },

                {
                    title: "  Reduce # of cars owned",
                    score: 1
                }


            ]

        }
    ]


}, {
    title: 'CONSUMPTION CHECKLIST',
    data: [
        {
            title: 'Water',
            data: [
                {
                    title: "Install low flow fixtures, aerators",
                    score: 1
                },
                {
                    title: "Take shorter showers",
                    score: 1
                },
                {
                    title: "Filter water instead of bottled",
                    score: 1
                },
                {
                    title: "Install smart/drip irrigation",
                    score: 1
                },
                {
                    title: "Replace turf w/drought tolerant",
                    score: 1
                },
                {
                    title: "Catch greywater or rainwater",
                    score: 1
                },

            ]
        },
        {
            title: "Food",
            data: [
                {
                    title: 'Eat plant-based meal ___days/wk',
                    score: 1
                },
                {
                    title: 'Eat a vegetarian or vegan diet',
                    score: 1
                },
                {
                    title: 'Eat whole foods not processed',
                    score: 1
                },
                {
                    title: 'Raise chickens',
                    score: 1
                },
                {
                    title: 'Buy fruits/veggies in season',
                    score: 1
                },
                {
                    title: 'Buy Organic',
                    score: 1
                },

            ]
        },
        {
            title: "Waste",
            data: [
                {
                    title: 'BYO bottle, dish, bag, jar',
                    score: 1
                },
                {
                    title: 'Compost/vermiculture',
                    score: 1
                },
                {
                    title: 'Recycle glass, plastic, metal',
                    score: 1
                },
                {
                    title: 'Repair, repurpose, or donate',
                    score: 1
                },
                {
                    title: 'Use rechargeable batteries',
                    score: 1
                },
                {
                    title: 'Buy in bulk/avoid packaging',
                    score: 1
                },
                {
                    title: 'Use cloth bags instead of paper',
                    score: 1
                }

            ]
        },
        {
            title: "Shopping",
            data: [
                {
                    title: 'Invest in higher quality stuff',
                    score: 1
                },
                {
                    title: 'Buy local & at farmers markets',
                    score: 1
                },
                {
                    title: 'Research with web, phone',
                    score: 1
                },
                {
                    title: 'Buy recycled products',
                    score: 1
                },
                {
                    title: 'Reduce unnecessary shopping',
                    score: 1
                }
            ]
        },
        {
            title: "Share or Rent",
            data: [
                {
                    title: "Share tools, equipment w/others",
                    score: 1
                },
                {
                    title: 'Trade services or expertise',
                    score: 1
                }
            ]
        }
    ]
},
    {
        title: 'HOME ENERGY SYSTEMS CHECKLIST',
        data: [
            {
                title: "Change System",
                data: [
                    {
                        title: 'Install photovoltaic panels (rooftop solar)',
                        score: 1
                    },
                    {
                        title: 'Get HVAC tune up',
                        score: 1
                    },
                    {
                        title: 'Replace HVAC filters 3–4x/year',
                        score: 1
                    },
                    {
                        title: 'Get a home energy audit',
                        score: 1
                    },
                    {
                        title: 'Install/program smart thermostat',
                        score: 1
                    },
                    {
                        title: 'Install weather stripping',
                        score: 1
                    },
                    {
                        title: 'Seal leaky windows and doors',
                        score: 1
                    },
                    {
                        title: 'Upgrade to dual pane HE windows',
                        score: 1
                    },
                    {
                        title: 'Install a whole house fan',
                        score: 1
                    },
                    {
                        title: 'Install ceiling and attic fans',
                        score: 1
                    },
                    {
                        title: 'Install swamp or window fan units',
                        score: 1
                    },
                    {
                        title: 'Seal attic penetrations',
                        score: 1
                    },
                    {
                        title: 'Insulate and seal HVAC ducts',
                        score: 1
                    },
                    {
                        title: 'Insulate attic space to R39',
                        score: 1
                    },
                    {
                        title: 'Insulate walls',
                        score: 1
                    },
                    {
                        title: 'Install solar thermal water heater',
                        score: 1
                    },
                    {
                        title: 'Install efficient HVAC system',
                        score: 1
                    },
                    {
                        title: 'Install heat exchange radiant panel',
                        score: 1
                    },
                    {
                        title: 'Remove, disable, or seal off wood-burning fireplaces',
                        score: 1
                    },
                    {
                        title: 'Plant/build south & west side trees, shades, awnings, soffit',
                        score: 1
                    }

                ]
            }
        ]
    },
    {
        title: "HOME ENERGY CHECKLIST",
        data: [
            {
                title: 'Change Habits',
                data: [
                    {
                        title: "Keep windows and doors closed when AC or heat on",
                        score: 1
                    },
                    {
                        title: "Open windows on cool summer nights, let in winter sunshine",
                        score: 1
                    },
                    {
                        title: "Dry laundry on racks or lines",
                        score: 1
                    },
                    {
                        title: "Turn off lights not in use",
                        score: 1
                    },
                    {
                        title: "Close chimney flue seasonally",
                        score: 1
                    },
                ]
            },
            {
                title: 'Change Settings',
                data: [
                    {
                        title: "Lower hot water heater temp",
                        score: 1,

                    },
                    {
                        title: "Lower thermostat in winter (68ºF or lower)",
                        score: 1,

                    },
                    {
                        title: "Raise thermostat in summer (78ºF or higher)",
                        score: 1,

                    }
                ]
            },
            {
                title: 'Change Products',
                data: [
                    {
                        title: 'Buy Energy Star appliances and electronics',
                        score: 1
                    },
                    {
                        title: 'Use smart strips with timers for lights and electronics',
                        score: 1
                    },
                    {
                        title: 'Use light dimmers',
                        score: 1
                    },
                    {
                        title: 'Buy solar powered devices',
                        score: 1
                    },
                    {
                        title: 'Down size refrigerators/freezers',
                        score: 1
                    },
                    {
                        title: 'Use a solar cooker or microwave',
                        score: 1
                    },
                    {
                        title: 'Install LED bulbs (low Kelvin)',
                        score: 1
                    },
                    {
                        title: 'Install motion detector lights',
                        score: 1
                    },
                    {
                        title: 'Install skylights/solartubes',
                        score: 1
                    },
                ]
            }
        ]
    }
]

export const task_color = {
    'TRANSPORTATION CHECKLIST': {
        'back_ground_color': 'bg-blue-200',
        'title_color': 'text-blue-900',
        'title_color_sec': 'text-blue-900'
    },
    'CONSUMPTION CHECKLIST': {
        'back_ground_color': 'bg-green-200',
        'title_color': 'text-green-700',
        'title_color_sec': 'text-green-700'
    },
    'HOME ENERGY SYSTEMS CHECKLIST': {
        'back_ground_color': 'bg-yellow-100',
        'title_color': 'text-yellow-500',
        'title_color_sec': 'text-yellow-500'
    },
    'HOME ENERGY CHECKLIST': {
        'back_ground_color': 'bg-red-100',
        'title_color': 'text-red-500',
        'title_color_sec': 'text-red-500'
    },


}
